import React from 'react'
import hermods from './images/project-hermods.jpg'
import intra from './images/project-intra.jpg'
import uniross from './images/project-uniross.jpg'

export const getProjectImage = id => {
  switch(id) {
    case 'hermods': return hermods;
    case 'intra': return intra;
    case 'uniross': return uniross;
    default:
      return null;
  }
}




// WEBPACK FOOTER //
// ./src/imageHelper.js